export default __webpack_public_path__ + "static/media/001-knife.be050fce.png";